import { useFaceApi } from "./FaceApi";

export function ModelLoadingScreen({ children }: { children: React.ReactNode }) {
  const { modelsLoaded, loadingProgress, loadingError } = useFaceApi();

  if (loadingError) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <p>Error while Loading Face Recognition: {loadingError}</p>
      </div>
    );
  }

  if (!modelsLoaded) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <p>Models being loaded... ({loadingProgress}%)</p>
        <div style={{ width: 300, height: 8, background: "#eee", borderRadius: 4, overflow: "hidden" }}>
          <div
            style={{
              width: `${loadingProgress}%`,
              height: "100%",
              background: "#4a90e2",
              transition: "width 0.2s ease",
            }}
          />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}